<template>
  <div
    id="new-feature-modal"
    class="modal fade"
    style="background: rgba(0,0,0,0.5)"
    v-bind:class="{ show: show }"
    tabindex="-1"
    role="dialog"
    aria-labelledby="vcenter"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" :class="side && 'side'">
      <div class="modal-content" id="modal">
        <div class="card-body">
          <div
            class="d-flex col-gap-1 pb-3"
            style="border-bottom: 1px solid rgba(0, 0, 0, 0.1); align-items:baseline"
          >
            <span
              class="mx-0 px-2 mb-0 rounded-pill font-14"
              style="background-color:#213e7a; color:white"
            >
              {{ $t("new") }}
            </span>
            <h5 class="mx-0 px-2 mb-0 font-bold">
              {{ $t("update") }}
            </h5>
            <span
              @click="close"
              style="margin-left:auto"
              class="position-relative cursor-pointer"
            >
              <IconX />
            </span>
          </div>

          <div class="scroll">
            <div class="pt-3">
              <span class="d-flex col-gap-1 align-items-baseline">
                <p
                  class="p-2 gray6"
                  style="font-size: 1rem; color:#213e7a; font-weight: 600;"
                >
                  {{ $t("new!") }}
                </p>
                <p class="p-2 gray6" style="font-size: 1rem;">
                  {{ $t("intro-report") }}
                </p>
              </span>
              <p class="description pb-3 mb-0">
                {{ $t("report") }}
              </p>
              <a
                href="https://support.gricd.com/knowledgebase/how-to-generate-reports-automatically/"
                target="_blank"
                class="pb-3"
                >{{ $t("learn") }}</a
              >
              <hr />
            </div>
            <div class="pt-2">
              <span class="d-flex col-gap-1 ">
                <p
                  class="p-2 gray6"
                  style="font-size: 1rem; color:#213e7a; font-weight: 600;"
                >
                  {{ $t("new!") }}
                </p>
                <p class="p-2 gray6" style="font-size: 1rem;">
                  {{ $t("intro-alarm") }}
                </p>
              </span>
              <p class="description pb-3 mb-0">
                {{ $t("alarm") }}
              </p>
              <a
                href="https://support.gricd.com/knowledgebase/what-is-the-alarms-feature/"
                target="_blank"
                class="pb-3"
                >{{ $t("learn") }}</a
              >
              <hr />
            </div>
            <div class="pt-2">
              <span class="d-flex col-gap-1 ">
                <p
                  class="p-2 gray6"
                  style="font-size: 1rem; color:#213e7a; font-weight: 600;"
                >
                  {{ $t("new!") }}
                </p>
                <p class="p-2 gray6" style="font-size: 1rem;">
                  {{ $t("intro-wallet") }}
                </p>
              </span>
              <p class="description pb-3 mb-0">
                {{ $t("wallet") }}
              </p>
              <a
                href="https://support.gricd.com/knowledgebase/what-is-the-wallet-feature/"
                target="_blank"
                class="pb-3"
                >{{ $t("learn") }}</a
              >
              <hr />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconX from "../../components/Iconsvg/IconCancel.vue";
export default {
  name: "NewFeature",
  props: {
    show: Boolean,
    side: Boolean,
  },
  methods: {
    // startTour() {
    //   this.$emit("start-tour");
    // },
    close() {
      this.$emit("close");
    },
  },
  components: {
    IconX,
  },
};
</script>

<style scoped>
.modal-dialog {
  max-width: 31.25rem !important;
}
@media (min-width: 1920px) {
  .modal-dialog {
    max-width: 40.25rem !important;
  }
  .description {
    font-size: 1.3rem !important;
  }
  p {
    font-size: 1.3rem !important;
  }
  span {
    font-size: 1.2rem !important;
  }
  h5 {
    font-size: 1.3rem !important;
  }
  a {
    font-size: 1.3rem !important;
  }
}
@media (min-width: 1600px) {
  .modal-dialog {
    max-width: 39.25rem !important;
  }
  .description {
    font-size: 1.3rem !important;
  }
  p {
    font-size: 1.3rem !important;
  }
  span {
    font-size: 1.2rem !important;
  }
  h5 {
    font-size: 1.3rem !important;
  }
  a {
    font-size: 1.3rem !important;
  }
}
.description {
  font-family: Sarabun;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 140.62%;
  /* or 22px */

  /* Primary Text */

  color: #404a57;

  /* border-bottom: 1px solid rgba(0, 0, 0, 0.1); */
}
.side {
  margin-left: auto !important;
  margin-right: 0 !important;
}

a {
  color: #404a57;
  text-decoration: underline;
  font-family: Sarabun;
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 140.62%;
}
.scroll {
  max-height: 70vh;
  overflow-y: auto;
}
.modal-content {
  overflow-y: clip;
  max-height: fit-content;
}
@media (max-width: 576px) {
  .modal-content {
    width: 90%;
    margin-left: auto;
  }
}
</style>

<i18n>
{
	"en": {
		"alarm": "Do you wish to get an SMS or email notification when things go wrong or when your products leave a certain area? With the Alarms feature you can set what parameter you want to track and get notifications for e.g Temperature / Humidity Excursions, Battery Level, GeoFence exits / entry, etc.",
		"intro-alarm": "Introducing New Alarm Feature",
		"intro-report": "Introducing the Report Feature",
		"intro-wallet": "Introducing the Wallet Platform",
		"learn": "Learn more",
		"new": "New",
		"new!": "New!",
		"report": "If you need the report of storage conditions of your products on a regular basis, then this feature is for you. It helps you schedule and generate reports automatically either daily, weekly or monthly",
		"update": "What we have been up to",
		"wallet": "We’re thrilled to announce the SMS wallet feature which helps you manage and purchase SMS Units. The SMS units are needed for the delivery of SMS notifications whenever there are excursions or based on parameters being tracked in your Alarm Setting."
	},
	"fr": {
		"alarm": "Souhaitez-vous recevoir une notification par SMS ou par e-mail lorsque les choses tournent mal ou lorsque vos produits quittent une certaine zone ? Avec la fonction Alarmes, vous pouvez définir le paramètre que vous souhaitez suivre et recevoir des notifications pour, par exemple, les excursions de température/humidité, le niveau de batterie, les sorties/entrées GeoFence, etc.",
		"intro-alarm": "Présentation de la nouvelle fonction d'alarme",
		"intro-report": "Présentation de la fonction de rapport",
		"intro-wallet": "Présentation de la plate-forme de portefeuille",
		"learn": "apprendre encore plus",
		"new": "Nouveau",
		"new!": "Nouveau!",
		"report": "Si vous avez régulièrement besoin du rapport des conditions de stockage de vos produits, cette fonctionnalité est faite pour vous. Il vous aide à planifier et à générer automatiquement des rapports quotidiens, hebdomadaires ou mensuels",
		"update": "Ce que nous avons fait",
		"wallet": "Nous sommes ravis d'annoncer la fonction de portefeuille SMS qui vous aide à gérer et à acheter des unités SMS. Les unités SMS sont nécessaires pour la livraison de notifications SMS chaque fois qu'il y a des excursions ou en fonction des paramètres suivis dans votre réglage d'alarme."
	},
	"sw": {
		"alarm": "Je, ungependa kupokea arifa ya SMS au barua pepe mambo yanapoenda kombo au bidhaa zako zinapoondoka katika eneo fulani? Ukiwa na kipengele cha Kengele unaweza kuweka kigezo unachotaka kufuatilia na kupata arifa kwa mfano Matembezi ya Halijoto / Unyevu, Kiwango cha Betri, njia za kutoka/kuingia za GeoFence, n.k.",
		"intro-alarm": "Tunakuletea Kipengele Kipya cha Kengele",
		"intro-report": "Tunakuletea Kipengele cha Ripoti",
		"intro-wallet": "Tunakuletea Mfumo wa Wallet",
		"learn": "Jifunze zaidi",
		"new": "mpya",
		"new!": "Mpya!",
		"report": "Ikiwa unahitaji ripoti ya hali ya uhifadhi wa bidhaa zako mara kwa mara, basi kipengele hiki ni kwa ajili yako. Inakusaidia kuratibu na kutoa ripoti kiotomatiki kila siku, kila wiki au kila mwezi",
		"update": "Nini tumekuwa juu",
		"wallet": "Tunayofuraha kutangaza kipengele cha pochi ya SMS ambacho hukusaidia kudhibiti na kununua Vitengo vya SMS. Vipimo vya SMS vinahitajika kwa ajili ya uwasilishaji wa arifa za SMS wakati wowote kuna safari au kulingana na vigezo vinavyofuatiliwa katika Mipangilio yako ya Kengele."
	}
}
</i18n>
